import React from 'react'

import progData from '../../data/groupes.json'
import VisibleComponent from '../../shared/VisibleComponent'
import Evening from './Evening'
import Events from './Events'
import Masterclasses from './Masterclasses'

const Programmation = () => {
  return (
    <VisibleComponent>
      <div className="elements-group">
        <h2 id="programmation">Programmation 2026</h2>
        <div className="groupes">
          {progData.map((value) => (
            <VisibleComponent>
              <div className={`programmation-${value.date} jour`}>
                <h3>
                  {`${
                    value.date.charAt(0).toUpperCase() + value.date.slice(1)
                  }`}{' '}
                  {value.place != null && '-'} {value.place}{' '}
                  {value.time != null && '-'} {value.time}
                </h3>
                {value.description != null && (
                  <p className="informations">{value.description}</p>
                )}
                {/* {key.includes('vendredi') ? <Vendredi /> : <Samedi />} */}

                <Events events={value.events} />
                {value.masterclasses != null && (
                  <Masterclasses masterclasses={value.masterclasses} />
                )}
                {value.evening != null && <Evening evening={value.evening} />}
              </div>
            </VisibleComponent>
          ))}
        </div>
      </div>
    </VisibleComponent>
  )
}

export default Programmation
